"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OSRWindow = void 0;
const window_type_1 = require("./enums/window_type");
const window_base_1 = require("./window_base");
class OSRWindow extends window_base_1.WindowBase {
    // ---------------------------------------------------------------------------
    constructor(options, id) {
        super(options, null);
    }
    // ---------------------------------------------------------------------------
    type() {
        return window_type_1.WindowType.Offscreen;
    }
    // ---------------------------------------------------------------------------
    resize(edge, rect) {
        throw new Error('Method not implemented.');
    }
    // ---------------------------------------------------------------------------
    // create for existing window
    get desktopOnly() {
        var _a;
        return ((_a = this.options) === null || _a === void 0 ? void 0 : _a.desktopOnly) || super.desktopOnly;
    }
}
exports.OSRWindow = OSRWindow;
//# sourceMappingURL=osr_window.js.map